import { BorderButton } from "src/components/buttons/BorderButton";
import Container from "src/components/layout/Container";
import { useListBackground } from "src/utils/setListBackground";
import { useSearchParams } from "src/utils/useSearchParams";

export default function UsaSwimmingComplete() {
  const params = useSearchParams();
  useListBackground();

  return (
    <Container full main className="bg-white">
      <Container className="pt-16">
        <div className="text-center">
          <div className="mb-2">
            <i className="far fa-circle-check text-5xl text-success" />
          </div>

          <h2>The sync is complete.</h2>

          <BorderButton type="submit" to="/admin">
            Return home
          </BorderButton>

          <hr className="my-10" />

          <h2>Ideas for what to do next…</h2>

          <div className="mx-auto mb-8 flex max-w-sm flex-col gap-2">
            <BorderButton to={`/admin/group-offerings/add`}>
              Create a training group{" "}
              <i className="far fa-arrow-right ml-2 text-organization" />
            </BorderButton>

            <BorderButton
              to={`/admin/membership-offerings/${params.get("offering")}`}
            >
              Place swimmers in a training group{" "}
              <i className="far fa-arrow-right ml-2 text-organization" />
            </BorderButton>
          </div>
        </div>
      </Container>
    </Container>
  );
}
